import axios from 'axios'
import keycloak from '../keycloak.js'
import store from '../redux/store.js'
import { setLoading, setSilent } from '../redux/meta.js'
import { env } from '../../env.js'
import { toast } from 'react-toastify'
let errorShown = false


export const Api = (() => {
    const instance = axios.create({
        baseURL: env.API_URL + '/api',
        timeout: 10000, // 10 second timeout
    })

    instance.interceptors.request.use(
        (config) => {
            if (!store.getState().meta.silent) store.dispatch(setLoading(true))
            config.headers['Authorization'] = 'Bearer ' + keycloak.token
            config.headers['X-Requested-With'] = 'XMLHttpRequest'
            return config
        },
        (error) => {
            // Handle request configuration errors
            store.dispatch(setLoading(false))
            if (!errorShown) {
                toast.error(
                    'Nie można porozumieć się z backendem, hej backend!!! Żyjesz?'
                )
                errorShown = true
            }
            console.error('Request configuration error:', error)
            return Promise.reject(error)
        }
    )

    instance.interceptors.response.use(
        (response) => {
            store.dispatch(setLoading(false))
            store.dispatch(setSilent(false))
            return response
        },
        (error) => {
            store.dispatch(setLoading(false))
            if (error?.response?.status === 401) {
                keycloak.login();
            } else if (error?.response?.status === 422 && error?.response?.data?.status === 'warning') {

                return error.response;
            } else if (error?.response?.status === 500 || error?.response?.status === 510) {

                return error.response;
            } else if (
                (error?.response?.status === 422 && error?.response?.data?.status !== 'warning') ||
                error?.response?.status === 403 || error?.response?.status === 404 || error?.response?.status === 400 || error?.response?.status === 406) {

                return error.response;
            } else if (error?.response?.message === undefined) {
                return error;
            } else {
                return error;
            }
            return error;
        }
    )
    return instance
})()

export default Api
